import type { Cart } from 'types/cart/Cart';
import type { CartLineItem } from 'types/cart/CartLineItem';
import type { ShopifyProduct } from 'types/product/ShopifyProduct';
import { getProductVariant } from 'utils/product/getProductVariant';

import { VENDOR } from '../constants';

interface CvgItem {
  product_id: string;
  variant_id?: string;
  sku?: string;
  name: string;
  variant_name?: string;
  price: number;
  currency: string;
  quantity: number;
  vendor?: string;
  image_url?: string;
}

interface CvgCart {
  total_price: number;
  total_tax: number;
  total_shipping: number;
  currency: string;
  items: CvgItem[];
}

export const itemPayloadFromProduct = (
  product: ShopifyProduct,
  merchandiseId: string,
): Omit<CvgItem, 'quantity'> | undefined => {
  const variant = getProductVariant(product, merchandiseId);

  if (!variant) return;

  return {
    product_id: product.id,
    variant_id: variant.id,
    name: product.title,
    variant_name: variant.title,
    price: variant.price.amount,
    currency: variant.price.currencyCode,
    vendor: VENDOR,
  };
};

export const itemPayloadFromLineItem = (lineItem: CartLineItem): CvgItem => ({
  product_id: lineItem.merchandise.product.id,
  variant_id: lineItem.merchandise.id,
  name: lineItem.merchandise.product.title,
  variant_name: lineItem.merchandise.title,
  price: lineItem.merchandise.price.amount,
  currency: lineItem.merchandise.price.currencyCode,
  quantity: lineItem.quantity,
  vendor: VENDOR,
});

export const cartPayload = (cart: Cart): CvgCart => {
  const items = cart.lines.map((li) => itemPayloadFromLineItem(li));
  return {
    total_price: cart.totalPrice.amount,
    total_tax: cart.cost.totalTaxAmount?.amount || 0,
    total_shipping: 0,
    currency: cart.totalPrice.currencyCode,
    items,
  };
};
